import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, secondaryColors } from '@tryhackme/thm-ui-components';

import { ReactComponent as DotsSmall } from 'src/images/svgs/subscriptions/dots-small.svg';

export const StyledContainer = styled.div`
  padding: 3rem 0 6rem 0;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 4.6rem 0 6rem 0;
    gap: 8rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    gap: 4rem;
  }
`;

export const StyledTextContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 0 1.2rem 0 1.2rem;
  z-index: 3;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    flex-direction: row;
    column-gap: 4rem;
    padding: 0 3.6rem 0 3.6rem;
  }
`;

export const StyledTitle = styled.p`
  font-style: italic;
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  color: ${({ theme }) => theme.colors.primary.main};
  margin-bottom: 0.8rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 1.9rem;
  }
`;

export const StyledIntro = styled.p`
  font-size: 2.4rem;
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  line-height: normal;
  color: ${secondaryColors.grey[100]};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  }
`;

export const StyledDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  color: ${secondaryColors.grey[200]};
  line-height: normal;
  margin: 2.4rem 0;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: 2.2rem;
  }
`;

export const StyledWhatsIncludedContainter = styled.div`
  color: ${secondaryColors.grey[200]};
  margin-top: 2.4rem;
  text-wrap: nowrap;

  p {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    font-style: italic;
    font-size: 1.9rem;
    margin-bottom: 1.6rem;
  }

  li {
    font-family: ${({ theme }) => theme.fonts.familyUbuntu};
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    margin-bottom: 1rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 0 2.4rem;
  }
`;

export const StyledCheckIcon = styled(FontAwesomeIcon)`
  width: 1.6rem;
  height: 1.8rem;
  margin-right: 0.8rem;
  color: ${({ theme }) => theme.colors.primary.main};
`;

export const StyledSVGContainer = styled.div`
  display: flex;
`;

export const StyledDotsSmall = styled(DotsSmall)`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 200%;
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: 100%;
    max-width: 200rem;
    left: 0;
    margin: 0 auto;
  }
`;

export const StyledManagementDashboardContainer = styled(Container)`
  z-index: 1;
  display: none;
  padding: 0 1.2rem 0 1.2rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: block;
    padding: 0 3.6rem 0 3.6rem;
  }
`;

export const StyledManagementDashboard = styled.img`
  width: 100%;
  margin-left: -0.5rem;
`;

export const StyledFade = styled.div`
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background: ${secondaryColors.black};
    filter: blur(4rem);
    height: 26rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    filter: blur(4.5rem);
    height: 20rem;
  }
`;
